import {
    Box,
    Card as MuiCard,
    CardContent,
    Typography,
} from '@material-ui/core'
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)(spacing);
const InfoIcon = styled.img`
    height: 56px;
    width: 56px;
`
export const InfoCard = () => {
    const { t } = useTranslation();
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {t("questionUnits_faq1")}
                </Typography>
                <Box mt={4}>
                    <InfoIcon src="/static/img/icons/infoIcon.svg" />
                </Box>
                <Box mt={1}>
                    <Typography variant="h6" gutterBottom>
                       {t("questionUnits_faq2")}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="body2" gutterBottom style={{ color: 'rgba(238, 238, 238, 0.5)' }}>
                        {t("questionUnits_faq2_1")}
                    </Typography>
                </Box>
                <Box mt={2}>
                    <Typography variant="h6" gutterBottom>
                        {t("questionUnits_faq3")}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="body2" gutterBottom style={{ color: 'rgba(238, 238, 238, 0.5)' }}>
                        {t("questionUnits_faq3_1")}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    )
}